// consoleWrapper.js

const disableLogsInProduction = true;

(function() {
    // Vérifiez si l'environnement est la production
    if ((process.env.NODE_ENV === 'production') && disableLogsInProduction) { //à changer
        // Désactivez les méthodes de console que vous ne souhaitez pas en production
        console.log = () => {};
        console.info = () => {};
        console.debug = () => {};
        // Vous pouvez laisser console.warn et console.error actives si nécessaire
    } else {
        // En développement, vous pouvez laisser les méthodes intactes ou ajouter des fonctionnalités supplémentaires
        // Par exemple, ajouter des préfixes pour mieux identifier les logs
        const originalLog = console.log;
        console.log = (...args) => {
            originalLog('DEBUG:', ...args);
        };
    }
})();
